import { InjectionToken } from "@angular/core";

export interface HelpdeskToolkitEndpoints {
    test: string;
}

export const HELPDESK_TOOLKIT_ENDPOINTS = new InjectionToken<HelpdeskToolkitEndpoints>("Helpdesk Toolkit endpoints");
